module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Increase contract amount","increaseLoanAmount":"Increase amount by"},"et":{"title":"Increase contract amount","increaseLoanAmount":"Increase amount by"},"ru":{"title":"Increase contract amount","increaseLoanAmount":"Increase amount by"}}')
  delete Component.options._Ctor
}
